var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldClass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: "1vw",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51068 11.7333L7.99957 9.83555L10.4885 11.7333L9.55512 8.65333L12.044 6.87999H8.99512L7.99957 3.64444L7.00401 6.87999H3.95512L6.44401 8.65333L5.51068 11.7333ZM7.99957 14.2222C7.13883 14.2222 6.32994 14.0589 5.5729 13.7322C4.81586 13.4055 4.15734 12.9622 3.59734 12.4022C3.03734 11.8422 2.59401 11.1837 2.26734 10.4267C1.94068 9.66962 1.77734 8.86073 1.77734 7.99999C1.77734 7.13925 1.94068 6.33036 2.26734 5.57333C2.59401 4.81629 3.03734 4.15777 3.59734 3.59777C4.15734 3.03777 4.81586 2.59444 5.5729 2.26777C6.32994 1.9411 7.13883 1.77777 7.99957 1.77777C8.86031 1.77777 9.6692 1.9411 10.4262 2.26777C11.1833 2.59444 11.8418 3.03777 12.4018 3.59777C12.9618 4.15777 13.4051 4.81629 13.7318 5.57333C14.0585 6.33036 14.2218 7.13925 14.2218 7.99999C14.2218 8.86073 14.0585 9.66962 13.7318 10.4267C13.4051 11.1837 12.9618 11.8422 12.4018 12.4022C11.8418 12.9622 11.1833 13.4055 10.4262 13.7322C9.6692 14.0589 8.86031 14.2222 7.99957 14.2222Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldClass);
export default __webpack_public_path__ + "static/media/gold_class.1a3959df5d52644e7a995cd3615296d9.svg";
export { ForwardRef as ReactComponent };